import React from 'react'

import { Helmet } from 'react-helmet'

import Header from '../components/header'
import Card from '../components/card'
import Footer from '../components/footer'
import './character.css'

const Character = (props) => {
  return (
    <div className="character-container">
      <Helmet>
        <title>Character - BharatKarade</title>
        <meta
          name="description"
          content="Hii i'm Bharat Karade, i have over 11+ years of experience in Game UI Design and graphic designs 2D in-depth knowledge of Drawing."
        />
        <meta property="og:title" content="Character - BharatKarade" />
        <meta
          property="og:description"
          content="Hii i'm Bharat Karade, i have over 11+ years of experience in Game UI Design and graphic designs 2D in-depth knowledge of Drawing."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/37270ff6-c20f-4c60-89cf-ed199b10be0f/dec54fbc-2bef-42e2-a2f0-7c793b6d3599?org_if_sml=1"
        />
      </Helmet>
      <Header rootClassName="header-root-class-name3"></Header>
      <section className="character-container1 Fade_in_up1">
        <span className="character-text">Character Arts</span>
        <div id="Grider" className="character-container2">
          <a
            href="https://iili.io/HVxNEXe.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxNEXe.jpg"
              Image_name="lord kartikeya"
              image_name="lord kartikeya"
              rootClassName="card-root-class-name9"
              className="character-component01"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxNceS.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxNceS.jpg"
              Image_name="Pumping"
              image_name="Pumping"
              rootClassName="card-root-class-name14"
              className="character-component02"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxN1I9.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxN1I9.jpg"
              Image_name="Cleopatra Adel"
              image_name="Cleopatra Adel"
              rootClassName="card-root-class-name13"
              className="character-component03"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxNGLu.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxNGLu.jpg"
              Image_name="Edgar Bones"
              image_name="Edgar Bones"
              rootClassName="card-root-class-name12"
              className="character-component04"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxNjdQ.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxNjdQ.jpg"
              Image_name="Ibrahim khan persia"
              image_name="Ibrahim khan persia"
              rootClassName="card-root-class-name20"
              className="character-component05"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxNVqb.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxNVqb.jpg"
              Image_name="lineartlakshmi"
              image_name="lineartlakshmi"
              rootClassName="card-root-class-name19"
              className="character-component06"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxNXrx.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxNXrx.jpg"
              Image_name="mansing clouseup"
              image_name="mansing clouseup"
              rootClassName="card-root-class-name18"
              className="character-component07"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxNw7V.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxNw7V.jpg"
              Image_name="POP T pose"
              image_name="POP T pose"
              rootClassName="card-root-class-name17"
              className="character-component08"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxNNkB.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxNNkB.jpg"
              Image_name="tlakshmi"
              image_name="tlakshmi"
              rootClassName="card-root-class-name16"
              className="character-component09"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxNvhF.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxNvhF.jpg"
              Image_name="Tora Amber Norwegian"
              image_name="Tora Amber Norwegian"
              rootClassName="card-root-class-name15"
              className="character-component10"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxNtQn.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxNtQn.jpg"
              Image_name="Angry2"
              image_name="Angry2"
              rootClassName="card-root-class-name11"
              className="character-component11"
            ></Card>
          </a>
        </div>
      </section>
      <Footer rootClassName="footer-root-class-name3"></Footer>
    </div>
  )
}

export default Character
